module.exports = new __parcel__URL__("DogeLogo.58faeab6.svg").toString();